/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

/**
 * Loading state interface.
 *
 * Represents the state of an object that is loading.
 */
export interface LoadingStateInterface {
    loading: boolean;
    textKey: string;
    error: boolean;
    errorKey: string;

    start(): void;
    complete(): void;
    failed(errorKey?: string): void;
}

/**
 * Loading state.
 *
 * Concrete representation of the LoadingStateInterface.
 */
export class LoadingState implements LoadingStateInterface {
    public loading: boolean;
    public textKey!: string;
    public error: boolean;
    public errorKey!: string;

    /**
     * Constructor.
     *
     * @param {boolean} loading
     * @param {boolean} error
     * @param {string|undefined} textKey
     * @param {string|undefined} errorKey
     */
    constructor(loading: boolean = false, error: boolean = false, textKey?: string, errorKey?: string) {
        this.loading = loading;
        this.error = error;

        if (undefined !== textKey) {
            this.textKey = textKey;
        }

        if (undefined !== errorKey) {
            this.errorKey = errorKey;
        }
    }

    /**
     * Method used to set the state as having been completed (successfully).
     */
    public start(): void {
        this.loading = true;
        this.error = false;
    }

    /**
     * Method used to set the state as having been completed (successfully).
     */
    public complete(): void {
        this.loading = false;
        this.error = false;
    }

    /**
     * Method used to set the state as having failed.
     */
    public failed(errorKey?: string): void {
        if (undefined !== errorKey) {
            this.errorKey = errorKey;
        }
        this.loading = false;
        this.error = true;
    }
}
